module.exports = __webpack_public_path__ + "img/69e4a74.jpg";